import type { TopicDetail } from "@/mocks/topicDetails";

export default function TopicArticle({ detail }: { detail: TopicDetail }) {
  return (
    <div className="flex flex-col gap-10">
      <section aria-label="事件概述">
        <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
          <span className="flex h-7 w-7 items-center justify-center rounded-md bg-primary-100 text-primary-600">
            <i className="ri-article-line"></i>
          </span>
          事件概述
        </h2>
        <div className="mt-4 flex flex-col gap-4">
          {detail.intro.map((paragraph) => (
            <p key={paragraph.slice(0, 12)} className="text-sm leading-7 text-foreground-700 md:text-base md:leading-8">
              {paragraph}
            </p>
          ))}
        </div>
      </section>

      <section aria-label="事件回顾时间线">
        <h2 className="flex items-center gap-2 font-heading text-xl font-bold text-foreground-950">
          <span className="flex h-7 w-7 items-center justify-center rounded-md bg-accent-100 text-accent-700">
            <i className="ri-history-line"></i>
          </span>
          事件回顾
        </h2>
        <ol className="mt-5 border-l border-background-300 pl-6">
          {detail.timeline.map((event, index) => (
            <li key={event.title} className="relative pb-7 last:pb-0">
              <span
                className={
                  index === 0
                    ? "absolute -left-[31px] top-1 flex h-2.5 w-2.5 items-center justify-center rounded-full bg-primary-500 ring-4 ring-primary-100"
                    : "absolute -left-[31px] top-1 flex h-2.5 w-2.5 items-center justify-center rounded-full bg-background-400 ring-4 ring-background-100"
                }
              ></span>
              <span className="text-xs font-label font-medium text-secondary-600">{event.time}</span>
              <h3 className="mt-1 font-heading text-base font-bold text-foreground-900">
                {event.title}
              </h3>
              <p className="mt-1 text-sm leading-relaxed text-foreground-600">{event.desc}</p>
            </li>
          ))}
        </ol>
      </section>
    </div>
  );
}